import base from '../dr-base'
import drWidgetList from './dr-widget-list.vue'

const schema = {
  ...base,
  $Type: 'dr-widget-list',
  name: 'Widget list',
  group: 'Data widgets',
  icon: 'list-ul',
  properties: {
    ...base.properties,
    Value: {
      name: 'vuetifyWidgets.dr-widget-list.value',
      type: 'string'
    },
    Widgets: {
      type: 'array'
    },
    Pagination: {
      name: 'vuetifyWidgets.dr-widget-list.pagination',
      type: 'object',
      component: 'dr-widget-list-pagination-props-editor',
      properties: {
        NeedPagination: {
          name: 'vuetifyWidgets.dr-widget-list.pagination',
          type: 'boolean',
          default: false
        },
        AsyncMode: {
          name: 'vuetifyWidgets.dr-widget-list.asyncMode',
          type: 'boolean',
          default: false
        },
        ItemsCount: {
          name: 'vuetifyWidgets.dr-widget-list.itemsCount',
          type: 'string',
          hint: 'vuetifyWidgets.dr-widget-list.hint'
        },
        LinesPerPage: {
          name: 'vuetifyWidgets.dr-widget-list.linesPerPage',
          type: 'integer'
        }
      }
    }
  }
}

export default {
  schema,
  component: drWidgetList,
  propEditors: [
    {
      name: 'dr-prop-action'
    },
    {
      name: 'dr-widget-list-pagination-props-editor'
    }
  ]
}
  